import { PROJECT_TYPE } from './const';

export const isContinuousOptimizationType = (projectType) => {
  return [PROJECT_TYPE.wtmHomePage, PROJECT_TYPE.continuousOptimization].includes(projectType);
};

export const isDocumentProject = (projectType) => {
  return (
    !isContinuousOptimizationType(projectType) &&
    ![PROJECT_TYPE.blogPostBuilder, PROJECT_TYPE.longFormBuilder].includes(projectType)
  );
};

export const isBlogPostProject = (projectType) => projectType === PROJECT_TYPE.blogPostBuilder;

export const isLongFormProject = (projectType) => projectType === PROJECT_TYPE.longFormBuilder;
